module.exports = __webpack_public_path__ + "static/media/why-regional.0f82687c.jpg";